export default {"src":"/_next/static/media/tab-calendar.74874faa.svg","height":40,"width":41};